import { render } from "./CorporatePlanClimateGraphsComponent.vue?vue&type=template&id=9461fed4"
import script from "./CorporatePlanClimateGraphsComponent.vue?vue&type=script&lang=js"
export * from "./CorporatePlanClimateGraphsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__